let lastRefresh = 0;
const refreshInterval = 60 * 1000; // 1 minute

const refresh = async () => {
    const client = useSanctumClient();

    try {
        useMaintenanceModes().value = (await client<Record<string, string | null>>("/api/maintenance")) ?? {};
    } catch (error) {
        console.error("Maintenance: Failed to fetch maintenance status:", error);
    }
};

/**
 * Middleware to redirect users to the maintenance page if the site is under maintenance. This is done for guest
 * pages like the registration. In the loyalty portal itself, we show a maintenance component per page if needed.
 */
export default defineNuxtRouteMiddleware(async (to) => {
    // Refresh data if it's older than the refresh interval. Also done on the maintenance page to show the custom message.
    if (Date.now() - lastRefresh > refreshInterval) {
        await refresh();
        lastRefresh = Date.now();
    }

    if (to.path === "/maintenance") {
        // If the user is already on the maintenance page, do nothing
        return;
    }

    const maintenanceModes = useMaintenanceModes().value;

    if ("registration" in maintenanceModes) {
        if (to.path.startsWith("/register")) {
            return navigateTo("/maintenance?message=registration");
        }
    }

    if ("login" in maintenanceModes) {
        if (to.path.startsWith("/login")) {
            return navigateTo("/maintenance?message=login");
        }
    }
});
